import { ADD_FILTER } from "./actionType"

export const addFilter = (data) => {
    return {
        type: ADD_FILTER,
        payload: data
    }
}